import React from "react";
import { ScanFlowV2 } from "crossdock/common/flow/ScanFlowV2";
import { createStartProcessingPalletCard } from "../InboundPalletLabelCardCreators";

export const StartProcessingPallet: React.FC = () => (
  <ScanFlowV2 onMountCardData={createStartProcessingPalletCard({})} />
);
